import {
  getCurrentInstance,
  onMounted,
  ref
} from 'vue'
import {
  useRoute,
  useRouter
} from 'vue-router'
import {
  useStore
} from 'vuex'
import moment from 'moment'
import iconDependency from '@/dependencies/iconDependency'
import { authUseCase } from '@/usecase'
import apiUseCase from '@/usecase/apiUseCase'
// import {
//   getListAgent,
//   openTicketUseCase,
//   courierUseCase,
//   globalSettingUseCase
// } from '@/domain/usecase'
import environment from '@/configs/environtment'
// import { cloneDeep, isEmpty } from 'lodash'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { isNull } from 'lodash'

const modules = 'deliveryItem'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const app = getCurrentInstance()
    const listGlobalSetting = ref([])
    const icons = ref(iconDependency()) as any
    const {
      $toast,
      $strInd
    } = app!.appContext.config.globalProperties

    const checkResponse = (data: any) => {
      $toast.add({
        severity: 'error',
        detail: data.message,
        group: 'bc',
        life: 3000
      })
    }
    const login = async () => {
      const data = new URLSearchParams() as any
      const allowedRole = ['admin', 'roster', 'setoran', 'adminkontrol', 'external']
      const token = localStorage.getItem('ut')
      console.log('token', token)
      if (token) {
        store.dispatch('fetchProfile')
          .then(async (response) => {
            console.log('store', store.state)
            // if (!allowedRole.includes(store.state?.userProfile?.RolesName.toLowerCase())) {
            //   $toast.add({
            //     severity: 'error',
            //     detail: 'Anda tidak memiliki hak akses. Harap hubungi administrator',
            //     group: 'bc',
            //     closable: false,
            //     life: 3000
            //   })
            //   store.dispatch('logoutAccount')
            //   router.push({
            //     name: 'Home'
            //   })
            // }
            store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
            window.location.href = '/hjp/'
            // console.log('response processGetToken', response)
          })
          .catch((err) => {
            // store.dispatch('logoutAccount')
            $toast.add({
              severity: 'error',
              detail: 'Token Kadaluwarsa',
              group: 'bc',
              life: 3000
            })
            // setTimeout(() => {
            //   router.push({
            //     name: 'Home'
            //   })
            // }, 500)
          })
      } else {
        await store.dispatch('logoutAccount')
        router.push({
          name: 'Home'
        })
      }
    }

    const test = async () => {
      const tokenUrl = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/token`
      // const code = route.query.code

      const verifier = localStorage.getItem('pkce_verifier')!
      console.log('verifier', verifier)
      const params = new URLSearchParams({
        grant_type: 'authorization_code',
        code: `${route.query.code}`,
        redirect_uri: environment.getSsoRedirectUri(),
        client_id: environment.getSsoClientId(),
        code_verifier: verifier,
      })

      const response = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      })
      console.log('response', response)
      if (!response.ok) {
        throw new Error('Token exchange failed')
      }
      const result: any = await response.json()

      // console.log(response.json())
      console.log('result', result)
      localStorage.setItem('ut', result.access_token)
      localStorage.setItem('rt', result.refresh_token)
      localStorage.setItem('tt', result.token_type)
      localStorage.setItem('it', result.id_token)
      localStorage.setItem('ei', result.expires_in)
      localStorage.removeItem('pkce_verifier')
      console.log('local', localStorage.getItem('it'))
      login()
      // return await response.json()
    }

    onMounted(() => {
      console.log('callback')
      test()
    })
    return {}
  }
}
